import axios, { delete as del, get, post, put } from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from './api';

axios.interceptors.request.use(
    config => config,
    e => Promise.reject(e),
);
axios.interceptors.response.use(
    response => response,
    e => {
        if (e?.response?.status === 401) {
            localStorage.removeItem('token');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        
        if (typeof e?.toJSON === 'function') {
            const error = e?.toJSON();
            if (error?.message === 'Network Error') {
                toast.warning(
                    localStorage.getItem('i18nextLng') === 'uz'
                        ? 'Voy, internetingiz uzildi-ku'
                        : 'Нет подключения к Интернету',
                );
            }
            if (process.env.NODE_ENV === 'development') {
                console.log(error);
            }
        }
        return Promise.reject(e);
    },
);
const Axios = (options = {}) => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    if (options.multipart) {
        // Let axios set Content-Type with boundary automatically for FormData
    }
    const defaultOptions = {
        baseURL: API_URL,
        headers,
        // params: { lan: localStorage.getItem('i18nextLng') || 'uz', }
    };
    return {
        get: (url, opt = {}) => get(url, { ...defaultOptions, ...opt }),
        post: (url, data, opt = {}) =>
            post(url, data, { ...defaultOptions, ...opt }),
        put: (url, data, opt = {}) =>
            put(url, data, { ...defaultOptions, ...opt }),
        delete: (url, opt = {}) => del(url, { ...defaultOptions, ...opt }),
    };
};
export default Axios;